import { Phone, Mail, MapPin } from "lucide-react";
import { COMPANY, NAV_LINKS } from "../lib/constants";
import { useScrollTo } from "../hooks/useScrollTo";

export const Footer = () => {
  const go = useScrollTo();
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-[#C3E1F5] text-[#0B132B] pt-16 pb-8 overflow-hidden"
    >
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_30%_20%,#F6B800,transparent_50%)]" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid md:grid-cols-12 gap-10 pb-12 border-b border-[#0B132B]/12">
          <div className="md:col-span-5">
            <img src={COMPANY.logo} alt="TECH THRISSUR — Own The Best!" className="footer-brand-logo" width="588" height="642" data-testid="footer-logo" loading="lazy" />
            <p className="text-[#0B132B]/70 leading-relaxed text-sm max-w-md">
              Premium solar energy solutions for residential, commercial,
              industrial, and agricultural projects across Kerala. Powered by
              Enphase microinverter technology.
            </p>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-display font-semibold text-[#0F4C81] uppercase text-xs tracking-[0.18em] mb-4">
              Quick Links
            </h4>
            <ul className="space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.id}>
                  <button
                    onClick={() => go(l.id)}
                    data-testid={`footer-link-${l.id}`}
                    className="text-[#0B132B]/75 hover:text-[#0F4C81] transition-colors text-sm"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-4">
            <h4 className="font-display font-semibold text-[#0F4C81] uppercase text-xs tracking-[0.18em] mb-4">
              Contact
            </h4>
            <ul className="space-y-3 text-sm text-[#0B132B]/80">
              <li className="flex items-start gap-3">
                <MapPin className="w-4 h-4 mt-0.5 text-[#0c6f4e] flex-shrink-0" />
                <span>{COMPANY.address.line1}, {COMPANY.address.line2}</span>
              </li>
              <li className="flex items-start gap-3">
                <Phone className="w-4 h-4 mt-0.5 text-[#0c6f4e] flex-shrink-0" />
                <div>
                  <a data-testid="footer-call-primary" href={`tel:${COMPANY.phones[0].replace(/\s/g, "")}`} className="block hover:text-[#0F4C81]">{COMPANY.phones[0]}</a>
                  <a data-testid="footer-call-secondary" href={`tel:${COMPANY.phones[1].replace(/\s/g, "")}`} className="block hover:text-[#0F4C81]">{COMPANY.phones[1]}</a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <Mail className="w-4 h-4 mt-0.5 text-[#0c6f4e] flex-shrink-0" />
                <a data-testid="footer-email" href={`mailto:${COMPANY.email}`} className="hover:text-[#0F4C81] break-all">{COMPANY.email}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm">
          <p className="text-[#0B132B]/60" data-testid="footer-copyright">
            © {new Date().getFullYear()} Tech Thrissur. All rights reserved.
          </p>
          <p className="text-[#0B132B]/55">
            GSTIN: <span className="font-mono text-[#0B132B]/75">{COMPANY.gstin}</span>
          </p>
        </div>
      </div>
    </footer>
  );
};
